import { ArrowRight, Phone, Star } from "lucide-react";
import { HERO } from "@/constants/testIds";

export default function Hero() {
  const scrollToContact = () =>
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="top" className="relative isolate overflow-hidden bg-white text-[#334155]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 pt-16 pb-16 sm:pt-20 sm:pb-20 lg:pt-24 lg:pb-24">
        <div className="max-w-4xl fade-up">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-[2px] w-10 bg-[#0EA5E9]" />
            <span className="text-xs sm:text-sm font-bold uppercase tracking-[0.3em] text-[#0EA5E9]">
              Bay County, Florida · Since 2017
            </span>
          </div>

          <h1 className="font-heading font-black uppercase tracking-tighter leading-[0.92] text-5xl sm:text-7xl lg:text-8xl text-[#334155]">
            Transforming<br />
            Bay County Homes<br />
            <span className="text-[#0EA5E9]">One Coat At A Time.</span>
          </h1>

            <p className="mt-8 max-w-2xl text-base sm:text-lg text-[#4B5563] leading-relaxed">
              JJH Painting & Pressure Washing LLC is a local crew delivering crisp interior
              and exterior paint jobs, plus power washing that brings tired siding, driveways
              and decks back to life. We paint houses, apartments, condos, businesses,
              storefronts and more — across all of Bay County, from Panama City and Lynn
              Haven to Callaway, Parker, Springfield and beyond.
            </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <button
              data-testid={HERO.freeEstimateBtn}
              onClick={scrollToContact}
              className="group inline-flex items-center justify-center gap-3 bg-[#0EA5E9] hover:bg-[#0284C7] transition-colors text-white px-7 py-4 font-heading font-bold uppercase tracking-wider"
            >
              Get Free Estimate
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </button>
            <a
              data-testid={HERO.callBtn}
              href="tel:8505416842"
              className="inline-flex items-center justify-center gap-3 border-2 border-[#334155] hover:bg-[#334155] hover:text-white transition-colors px-7 py-4 font-heading font-bold uppercase tracking-wider text-[#334155]"
            >
              <Phone size={18} />
              Call 850-541-6842
            </a>
          </div>

          <div className="mt-12 flex flex-wrap items-center gap-x-8 gap-y-4 text-sm text-[#4B5563]">
            <div className="flex items-center gap-2">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={16} className="fill-[#0EA5E9] text-[#0EA5E9]" />
                ))}
              </div>
              <span className="font-semibold text-[#334155]">Trusted Local Crew</span>
            </div>
            <div className="hidden sm:block h-4 w-px bg-[#334155]/20" />
            <div className="font-semibold text-[#334155]">Licensed &amp; Insured</div>
            <div className="hidden sm:block h-4 w-px bg-[#334155]/20" />
            <div className="font-semibold text-[#334155]">Free In-Person Estimates</div>
          </div>
        </div>
      </div>

      <div className="border-t-2 border-[#334155] bg-[#334155]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-5 grid grid-cols-2 sm:grid-cols-4 gap-6 text-center sm:text-left">
          <Stat label="Serving Since" value="2017" />
          <Stat label="Hours" value="Mon–Sat 8a–5p" />
          <Stat label="Phone" value="850-541-6842" />
          <Stat label="Specialty" value="Paint + Wash" />
        </div>
      </div>
    </section>
  );
}

function Stat({ label, value }) {
  return (
    <div>
      <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#0EA5E9]">{label}</div>
      <div className="mt-1 font-heading font-bold uppercase text-white text-lg sm:text-xl tracking-tight">
        {value}
      </div>
    </div>
  );
}
